export default {"src":"/_next/static/media/invite-icon.088b5f77.svg","height":171,"width":234};